export default __webpack_public_path__ + "static/developers-popup-0074a4b210c4ea636d743ae2ec09936d.jpg";